var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('textarea',{staticStyle:{"width":"100%"},attrs:{"rows":"25"},domProps:{"value":_vm.value},on:{"input":_vm.emitInput}})])}
var staticRenderFns = []

export { render, staticRenderFns }